export enum StorageKeys {
  auth_token = 'authToken',
  main_data = 'mainData',
  keychain_data = 'keychainData',
  old_address = 'oldAddress',
  email = 'email',
  confirmation_token = 'confirmation_token',
}
